import {
	$apiurl,
	$wxatag,
	$version
} from '@/config.js';
import {
	$t,
	$showLoading,
	$hideLoading,
	$showToast,
	$hideToast,
	$getStorage,
	$setStorage,
	$query,
	$goTo,
	$getLang
} from '@/common/common.js'
import axios from 'axios'
import { v4 as uuidv4 } from 'uuid';
let token = null;
let bparam = null;
export async function $callapi(api, data = null) {
	if (!data) {
		data = {}
	}
	if (!token) {
		token = $getStorage("_token");
		if (!token) {
			// 创建token
			let chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz23456789'
			token = ''
			//以长度单位进行循环
			for (let i = 0; i < 32; ++i) {
				token += chars.charAt(Math.floor(Math.random() * chars.length))
			}
			$setStorage('_token', token);
		}
	}
	if (!bparam) {
		bparam = {
			_version: $version,
			_platform: $wxatag,

		}
	}
	Object.assign(data, bparam)
	data._version = $version
	data._platform = $wxatag
	let prod = process.env.NODE_ENV === 'production';
	if(!prod)
		data._token = token
	// data._lang = $getLang()
	if (api[0] != '/')
		api = '/api/' + api
	let url = $apiurl + api;
	return await new Promise((resolve, reject) => {
		axios.post(url, data).then(async res => {
			if (res.status != 200) {
				console.log('response', res)
				$showToast($t("请求失败") + res.statusCode, "none");
				resolve(null);
				return
			}
			let data = res.data;
			if (data) {
				if (data.code) {
					if (data.code != 2001) $showToast($t(data.msg), "none");
					
					setTimeout(() => {
						resolve(data)
					}, 2000)

					switch (data.code) {
						case 1000:
						case 2001:
							{
								$hideLoading();
								// 用户未登录
								if (await $query("登录后可以体验更多功能，是否现在去登录？")) {
									$goTo("/pages/login/login")
								}
								break;
							}
					}
				} else {
					resolve(data)
				}
			} else {
				resolve(res.data)
			}
		}).catch(err => {
			console.error(err);
			$showToast(err && err.errMsg || "请求失败", "none");
			resolve(null);
		})
	})
}

let $api = (m, p, succ, fail, timeout) => {
	var cacheKey = null;
	if (timeout) {
		cacheKey = m + '?' + Object.keys(p || {}).sort().map(k => {
			return `${k}=${p[k]}`;
		}).join('&');
	}
	let wsucc = (res, cache) => {
		succ && succ(res, cache);
		if (cacheKey && !cache) {
			let d = {
				res: res,
				time: Date.now()
			};
			$setStorage(cacheKey, JSON.stringify(d));
		}
	};
	if (cacheKey) {
		let s = $getStorage(cacheKey);
		if (s) {
			let d = JSON.parse(s);
			if (d && d.time) {
				let ttf = timeout * 1000 - (Date.now() - d.time);
				if (ttf >= 0) {
					wsucc(d.res, true);
				}
			}
		}
	}

	$callapi(m, p).then(res => {

		if (res && res.code == 0) {
			wsucc(res);
			// setTimeout(()=>{
			// 	wsucc(res);
			// }, 5000);
		} else {
			if (fail) {
				fail(res);
			} else {
				wsucc(res);
			}
			if (cacheKey) {
				$setStorage(cacheKey, null);
			}
		}
	}).catch(err => {
		fail(err)
	});
}

export class $Loader {
	apiname = null;
	param = {};
	showLoadding = true;

	data = null;
	loading = false;
	inited = false;
	cacheTimeout = 0; // 缓存时间(s)
	constructor(options) {
		if (typeof (options) == "string")
			options = {
				apiname: options
			};
		if (options) {
			Object.assign(this, options);
		}
	}
	onLoading() {
		if (this.showLoadding)
			$showLoading();
	}
	loaded(res) {
		if (this.showLoadding)
			$hideLoading();
	}

	onDataChange() {

	}
	handleResponse(res) {
		return res;
	}
	onError() {

	}
	reset() {
		this.data = null;
		this.onDataChange && this.onDataChange();
	}
	async load() {
		// 加载
		return new Promise((resolve, reject) => {
			// if (this.loading) {
			// 	reject("loading...")
			// }
			this.loading = true;
			var param = this.param;
			if (typeof (param) == 'function') {
				param = param();
			}

			this.onLoading && this.onLoading();
			$api(this.apiname, param, (res, cache) => {
				this.onLoaded && this.onLoaded(res);
				this.loaded();
				res = this.handleResponse(res);
				this.loading = false;
				if (res && res.data) {
					this.data = res.data;
					this.error = null;
					this.inited = true;
					this.onDataChange && this.onDataChange();
				} else {
					this.error = res && res.msg || "加载失败";
					this.onDataChange && this.onDataChange();
					this.onError && this.onError(res);
				} !cache && resolve(res);
			}, (res) => {
				this.onLoaded && this.onLoaded(res);
				this.loading = false;
				this.error = res && res.msg || "加载失败";
				this.onDataChange && this.onDataChange();
				this.onError && this.onError(res);
				// reject(res && res.msg ? res.msg : res);
				resolve(res);
			}, this.cacheTimeout);
		})
	}
}


export class $Pager {
	items = []
	data = null
	param = {}
	total = 0
	size = 10
	page = 1
	lastPage = 1
	hasNext = true
	hasPrev = true
	apiname = null
	cacheFirst = false
	loading = false
	inited = false
	showLoadding = true
	code = 0
	error = null
	constructor(options) {
		if (typeof (options) == "string")
			options = {
				apiname: options
			};
		if (options) {
			Object.assign(this, options);
		}
	}
	onLoading() {
		if (this.showLoadding) {
			$showLoading();
		}

	}

	loaded(res) {
		if (this.showLoadding) {
			$hideLoading();
		}

	}

	onDataChange() {

	}
	onError() {

	}
	reset() {
		this.items = [];
		this.page = 0;
		this.hasPrev = false;
		this.onDataChange && this.onDataChange();
	}
	async load(page, ismore) {
		return await new Promise((success, reject) => {
			var param = this.param;
			if (param && typeof (param) == 'function') {
				param = param() || {};
			}
			Object.assign(param, {
				size: this.size,
				page: page || this.page,
			});
			let oparam = this.getParam && this.getParam(this);
			if (oparam) {
				Object.assign(param, oparam);
			}
			var apiname = this.apiname;
			if (typeof (apiname) == 'function') {
				apiname = apiname();
			}
			this.onLoading && this.onLoading();
			this.loading = true;
			// let api = !ismore && this.cacheFirst ? app.B.fastapi : app.callapi;
			$api(apiname, param, (res, iscache) => {
				this.onLoaded && this.onLoaded(res);
				this.loaded();
				this.loading = false;
				if (res && res.data) {
					let data = res.data;
					if (ismore) {
						this.items = (this.items || []).concat(data.items);
					} else {
						this.items = data.items;
					}
					this.start = data.start;
					this.total = data.total;
					this.lastPage = Math.floor((this.total + this.size - 1) / this.size);
					if (page) {
						this.page = Math.max(1, Math.min(page, this.lastPage));
					}
					this.data = data;
					this.hasPrev = this.page > 1;
					this.hasNext = this.page < this.lastPage;
					this.error = null;
					this.inited = true;
					this.onDataChange && this.onDataChange();
				} else {
					this.error = res && res.msg || "加载失败";
					this.onDataChange && this.onDataChange();
					this.onError && this.onError(res);
					this.code = res.code
				}
				success(res);
			}, (res) => {
				console.log("res: ", res);
				this.onLoaded && this.onLoaded(res);
				this.loading = false;
				this.error = res && res.msg || "加载失败";
				this.onDataChange && this.onDataChange();
				this.onError && this.onError(res);
				success(null)
			}, this.cacheFirst ? 60 : 0);
		});
	}
	async first() {
		return await this.load(1)
	}
	async next() {
		return await this.load(this.page + 1)
	}
	async prev() {
		return await this.load(this.page - 1)
	}
	async more() {
		if (this.hasNext) {
			return await this.load(this.page + 1, true)
		} else {
			return null
		}
	}
	async reload() {
		return await this.load(this.page)
	}
}

export default {
	install(Vue) {
		Vue.prototype.$callapi = $callapi
		Vue.prototype.$apiurl = $apiurl
		Vue.prototype.$Loader = function (option) {
			return new $Loader(option);
		}
		Vue.prototype.$Pager = function (option) {
			return new $Pager(option);
		}
	}
}
